export const StockBasePath = "/stock";

const purchasingBasePath = "/stock/purchasing";

export const StockRoutePath = {
    pickList: "/stock/statistics",
    scanPrint: `${purchasingBasePath}/scan-print`,
    purchasingLabelStatistics: `${purchasingBasePath}/label-statistics`,
    purchasingLabelEdit: `${purchasingBasePath}/label-edit`,
    purchasingLabelEditRepository: `${purchasingBasePath}/label-edit/repository`,
    purchasingLabelEditCreate: `${purchasingBasePath}/label-edit/create`,
    marketAndWholesalerSetting: `${purchasingBasePath}/stall-setting`,
    sortationCodeSetting: `${purchasingBasePath}/sortation-code`,
};

const legacyPurchasingLabelTabPath: Record<string, string> = {
    scanPrint: StockRoutePath.scanPrint,
    purchasingLabelStatistics: StockRoutePath.purchasingLabelStatistics,
    purchasingLabelEdit: StockRoutePath.purchasingLabelEdit,
    marketAndWholesalerSetting: StockRoutePath.marketAndWholesalerSetting,
    sortationCodeSetting: StockRoutePath.sortationCodeSetting,
};

export function getPurchasingLabelEditTemplatePath(id: string | number) {
    return `${StockRoutePath.purchasingLabelEdit}/${id}`;
}

export function getLegacyPurchasingLabelRedirectTarget(pathname: string, search: string) {
    const params = new URLSearchParams(search);
    const tab = params.get("tab") || "";

    params.delete("tab");

    let nextPathname = legacyPurchasingLabelTabPath[tab] || StockRoutePath.scanPrint;

    if (pathname.startsWith("/features/purchasingLabel/repository")) {
        nextPathname = StockRoutePath.purchasingLabelEditRepository;
    } else if (pathname.startsWith("/features/purchasingLabel/create")) {
        nextPathname = StockRoutePath.purchasingLabelEditCreate;
    } else if (pathname.startsWith("/features/purchasingLabel/edit")) {
        const editMatch = pathname.match(/^\/features\/purchasingLabel\/edit\/([^/]+)/);

        nextPathname = editMatch
            ? getPurchasingLabelEditTemplatePath(editMatch[1])
            : StockRoutePath.purchasingLabelEdit;
    }

    const restSearch = params.toString();

    return {
        pathname: nextPathname,
        search: restSearch ? `?${restSearch}` : "",
    };
}
